<template>
  <div id="ieditoredit" >
    <!-- <div class="header">
      <el-row type="flex" justify="center" align="middle" :gutter="20" style="height:100%;">
        <el-col :xs="16" :sm="16" :md="14" :lg="10"> -->
          <!-- <span class="header-tips"> -->
          <!-- <span class="header-tips fs-label" v-if="editForm.edittime">上次保存于 {{editForm.edittime}}</span> -->
          <!-- </span> -->
        <!-- </el-col>
        <el-col :xs="6" :sm="6" :md="8" :lg="4">
          <span class="header-btn">
            <el-button @click="cancelForm" >取消</el-button>
            <el-button type="success" @click="submitForm('editForm')" >保存</el-button>
          </span>
        </el-col>
      </el-row>
    </div> -->

    <el-row type="flex" justify="center">
      <el-col :xs="24" :sm="24" :md="22" :lg="14">
        <div class="editor-content">
          <el-form :model="editForm" :rules="rules" ref="editForm" label-width="5rem">

           <el-form-item label="分类" required>
           <el-row type="flex" justify="start" :gutter="20">
              <el-col :span="4">
                <el-form-item prop="category">
                  <el-select v-model="editForm.rating" placeholder="分类" @change="handleJokeRatingChange">
                    <el-option
                      v-for="item in formatJokeRating"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col class="el-item" :span="2">场景</el-col>
              <el-col :span="8">
                <el-form-item prop="scenario">
                 <el-input v-model="editForm.scenario" placeholder="请输入场景" icon="circle-cross" :on-icon-click="handleSceneIconClick"></el-input>
                </el-form-item>
              </el-col>
              <el-col v-if="userType" class="el-item" :span="3">审核状态</el-col>
              <el-col v-if="userType" :span="7">
                <el-form-item>
                  <el-select v-model="editForm.status" placeholder="请输入审核状态">
                    <el-option
                      v-for="item in formatEventType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            </el-form-item>


            <el-form-item label="标题" prop="title">
              <el-input v-model="editForm.title" placeholder="请输入标题" icon="circle-cross" :on-icon-click="handleTitleIconClick"></el-input>
            </el-form-item>



            <el-form-item label="内容" prop="content">
              <el-input
                type="textarea"
                :autosize="{ minRows: 10, maxRows: 20}"
                placeholder="请输入内容"
                v-model="editForm.content">
              </el-input>
              <!-- <markdown-editor v-model="editForm.content" :configs="configs" ref="markdownEditor"></markdown-editor> -->
            </el-form-item>

            <el-form-item label="音频url" prop="audio">
              <el-input v-model="editForm.url" placeholder="请上传音频文件"><el-button slot="append">上传录音文件</el-button></el-input>
              <el-upload
                :action="postUrl"
                :data = "editForm.data"
                :multiple="false"
                :show-file-list="false"
                :on-remove="handleRemove"
                :on-success="handleSuccess"
                :on-error="handleError"
                :before-upload="handleBeforeUpload"
                ref="uploadTag">
                <el-button type="info" :loading="editForm.uploadloading" :disabled="editForm.done" v-if="editForm.mediaurl">重新上传</el-button>
                <el-button type="info" :loading="editForm.uploadloading" :disabled="editForm.done" v-else>上传录音</el-button>
              </el-upload>
            </el-form-item>

            <audio class="check-url" src="" controls="controls"></audio>

            <el-form-item label="标签" prop="tags">
              <el-col :span="24" class="el-item">
                <el-tag
                  type="gray"
                  v-for="tag in editForm.tags"
                  :key="tag.id"
                  :closable="true"
                  :close-transition="false"
                  @close="handleLabelClose(tag)"
                  class="editor-content-tags"
                >
                {{tag}}
                </el-tag>
                <!-- <el-button class="button-new-tag" size="small" @click="reqRcmdLabels">获取推荐标签</el-button> -->
              </el-col>
            </el-form-item>

            <el-form-item label="" prop="newlabels">
              <el-col :span="24" class="el-item">
                <el-tag
                  type="gray"
                  v-for="newtag in editForm.newlabels"
                  :key="newtag.id"
                  :closable="true"
                  :close-transition="false"
                  @close="handleClose(newtag)"
                  class="editor-content-tags"
                >
                {{newtag}}
                </el-tag>
                <el-input
                  class="input-new-tag"
                  v-if="inputVisible"
                  v-model="inputValue"
                  ref="saveTagInput"
                  size="mini"
                  @keyup.enter.native="handleInputConfirm"
                  @blur="handleInputConfirm"
                >
                </el-input>
                <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 新标签</el-button>
              </el-col>

            </el-form-item>
            <el-button class="submit-btn" type="success" @click="submitForm('editForm')" >保存</el-button>
          </el-form>

        </div>
      </el-col>

    </el-row>

  </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import { Message } from 'element-ui'
    // import { markdownEditor } from 'vue-simplemde';
    import { jokeRating,eventType, newsType, hotsType, newsPlatform, newsPlatformType, newsListAddr } from '../../config/config'
    import { getNowTime, cloneObj } from '../../utils/com.js'
    import CryptoJS from 'crypto-js'
    import '../../static/style/ieditor/edit.scss'

    const defaultRcmdBtnName = '点击获取推荐标签', loadingRcmdBtnName = '标签获取中……'
    export default {
        data: function(){
            return {
              rules: {
                rating: [
                  { required: true, message: '请选择分类', trigger: 'change' }
                ],
                scenario: [
                  { required: true, message: '请填写场景', trigger: 'change' },
                  { min: 1, max: 100, message: '长度在 1到 10 个字符', trigger: 'blur' }
                ],
                title: [
                  { required: true, message: '请输入标题', trigger: 'blur' },
                  { min: 3, max: 100, message: '长度在 3 到 100 个字符', trigger: 'blur' }
                ],
                content: [
                  { required: true, message: '请填写内容', trigger: 'blur' }
                ],

              },
                headerFolder: 'test/',
                postbFolder: '', //'test/20170720/',
                postUrl: 'https://be.jzyq.ltd/upload/audio',//'//cloud-news.oss-cn-shanghai.aliyuncs.com/', ////qhfm-res.oss-cn-beijing.aliyuncs.com/',
                cdnPostUrl: '//res.banma.jizhuoyangqing.com/',

                  value: '',
                  editForm: {
                    tags: [],
                    newlabels: [],
                    id: '',
                    rating: '',
                    scenario:'',
                    status:'',
                    title: '',
                    content: '',
                    url:'',
                    hotindex: '',
                    // cover: '',
                    editor: null,
                    // date: null,
                    // edittime: null,
                    tip: '',
                    data:{
                      osspath:'',
                      volumedb:'',
                      token:''
                    }
                  },

                dynamicTags: [],
                inputVisible: false,
                inputValue: '',
                rcmdLabelsText: defaultRcmdBtnName,
                rcmdBtnLoading: false,
                inputMinSize: 2,
                tag: '',
                newtag: '',
                oldRating: '',
                restaurants: [],
            }
        },
        computed: {
          ...mapGetters({
              // 映射 this.newsdata 为 store.getters.newContent
              newContent: 'newContent',
              newsdata: 'newsdata',
              newstotal: 'newstotal',
          }),
          formatJokeRating(){
              let typelists = [];
              for(let i in jokeRating){
                let typelist = {}
                typelist.value = i;
                typelist.label = jokeRating[i];
                typelists.push(typelist);
              }
              return typelists;
          },
          formatEventType(){
              let typelists = [];
              for(let i in eventType){
                let typelist = {}
                typelist.value = i;
                typelist.label = eventType[i];
                typelists.push(typelist);
              }
              return typelists;
          },
          userType(){ 
            console.log(this.$store.state.login.role);
            console.log(sessionStorage.getItem('userType'))
            
            return this.$store.state.login.role ==='admin' || sessionStorage.getItem('userType') ==='admin' ? true : false
          }
        },
        mounted() {
          this.restaurants = this.loadAll();
        },
        created() {
          this.id = this.$route.query.id || '';
          // console.log(this.id);
          let index = this.$route.query.index || 0;
          this.index = parseInt(index);
          // console.debug("created> id:%o, index:%o, newsdata:%o, newstotal:%o", this.id, this.index, this.newsdata, this.newstotal);
          if(this.id && this.newsdata){
            // console.log("created> item:%o", this.newsdata);
            let item = this.reqNewsContent(this.id, this.newsdata);
            // console.log("created> item:%o", item);
            if(item){
              this.updateNewsContent(item);
            }
          }


          // console.log("created> newContent:%o", this.newContent);
          if(this.newContent && this.$store.state.route.query.id && this.$store.state.route.query.id === this.newContent._id){

            this.editForm = cloneObj(this.newContent);
            console.log(this.editForm);
            //remove empty array
            let nl = this.newContent.tags.split('#')||[];
            nl = nl.filter(t => t!=undefined && t!==null && t !=='');
            this.editForm.tags = nl;
            this.editForm.newlabels = [];
            this.editForm.id = this.newContent._id;
            // this.editForm.category = newsType[this.newContent.category];
            this.editForm.rating = this.newContent.rating;
            this.editForm.title = this.newContent.title;
            this.editForm.content = this.newContent.content;
            this.editForm.scenario = this.newContent.scenario;//hotsType[this.newContent.hotindex];
            this.editForm.status = this.newContent.status || '';
            this.editForm.url = this.newContent.url;
            this.editForm.tip = this.newContent.tip;
            this.oldRating = this.editForm.rating;
            console.debug("created> editForm:%o, dynamicTags:%o, oldCategory:%o", this.editForm, this.dynamicTags, this.oldCategory);
          }
          else{
            this.editForm.tip = '';
          }
          console.debug("created> editForm:%o", this.editForm);
          if(this.editForm.tip){
            Message({
              showClose: true,
              duration: 0,
              message: `驳回理由: ${ this.editForm.tip }`,
              type: 'warning'
            });
          }
        },
        destroyed(){
          Message.closeAll();
        },
        methods: {
          ...mapActions({
            // 映射 this.editNewsContent() 为 this.$store.dispatch('editNewsContent')
            editNewsContent: 'editNewsContent',
            addNewsContent: 'addNewsContent',
            getNewLables: 'getNewLables',
            updateNewsContent: 'updateNewsContent',
          }),

          loadAll() {
            return newsListAddr;
          },

          reqNewsContent(id, datalist) {
            // console.log('reqNewsContent> id:%o, datalist:%o', id, datalist);
            if(!id || !datalist){
              return false;
            }
            // console.log(datalist);
            let data = null;
            let hasUser = datalist.some(u => {

              if (u._id === id ) {
                data = JSON.parse(JSON.stringify(u));
                return true;
              }
            });
            // console.log("reqNewsContent> hasUser:%o, data:%o", hasUser, data);
            return data;
          },

          handleJokeRatingChange(val){
            // console.debug("handleCategoryChange> val:%o, category:%o", val, this.editForm.rating);

            // console.debug("handleCategoryChange> editForm.labels:%o, newsType[%o]:%o", this.editForm.labels, this.oldRating, newsType[this.oldCategory]);
            // // if(this.editForm.labels.length>0 && newsType[this.oldCategory]){
            //   console.debug("handleCategoryChange> before labels:%o", this.editForm.labels);
            //   this.editForm.labels = this.editForm.labels.filter(t => t !== newsType[this.oldRating]);
            //   this.editForm.labels.push(newsType[this.editForm.rating]);
            //   console.debug("handleCategoryChange> after labels:%o", this.editForm.labels);
            // // }
            // this.oldRating = this.editForm.rating;
          },
          // handleHotChange(val){
          //   console.debug("handleHotChange> val:%o, hotindex:%o", val, this.editForm.hotindex);
          // },

          // reqRcmdLabels() {
          //   if(!this.editForm.title || !this.editForm.content){
          //     let msg = '标题 或 内容 不能为空。'
          //     this.$message({
          //           message: msg,
          //           type: 'warning'
          //       });
          //     return false;
          //   }
          //   var that = this;
          //   let param = {
          //       content: this.editForm.title + this.editForm.content,
          //   }
          //   this.rcmdBtnLoading = true;
          //   this.rcmdLabelsText = loadingRcmdBtnName;
          //   console.debug("reqRcmdLabels> getNewLables> param:%o", param);
          //   this.getNewLables(param).then(
          //     (resp) => {
          //       console.debug("reqRcmdLabels> getNewLables> resp:%o", resp);
          //       that.rcmdBtnLoading = false;
          //       that.rcmdLabelsText = defaultRcmdBtnName;
          //       if(resp && resp.code !== 0){
          //         that.$message({
          //               message: resp.msg,
          //               type: 'error'
          //           });
          //       }else{
          //         let nl = [], rnl = [];
          //         // if(this.newContent.labels){
          //         //   nl = this.newContent.labels.split('#');
          //         //   nl = nl.filter(t => t!=undefined && t!==null && t !=='');
          //         // }
          //         nl = this.editForm.tags;
          //         // console.debug("reqRcmdLabels> nl:%o", nl);
          //         if(resp.data.labels){
          //           rnl = resp.data.labels.split('#');
          //           rnl = rnl.filter(t => t!=undefined && t!==null && t !=='');
          //         }
          //         // console.debug("reqRcmdLabels> rnl:%o", rnl);
          //         if(this.editForm.category){
          //           nl.push(newsType[this.editForm.category]);
          //         }
          //         nl = nl.concat(rnl);
          //         console.debug("reqRcmdLabels> before nl:%o", nl);
          //         nl = this.arryDerep(nl); //nl.derep();
          //         console.debug("reqRcmdLabels> after nl:%o", nl);
          //         this.editForm.tags = nl;
          //       }
          //     }
          //   );
          // },

          handleLabelClose(tag) {
            this.editForm.tags.splice(this.editForm.tags.indexOf(tag), 1);
            // console.debug("handleLabelClose> tag:%o, labels:%o, ", tag, this.editForm.labels);
          },

          handleClose(tag) {
            this.editForm.newlabels.splice(this.editForm.newlabels.indexOf(tag), 1);
            // console.debug("handleClose> tag:%o, newlabels:%o, ", tag, this.editForm.newlabels);
          },

          showInput() {
            this.inputVisible = true;
            this.$nextTick(_ => {
              this.$refs.saveTagInput.$refs.input.focus();
            });
          },

          handleInputConfirm() {
            let inputValue = this.inputValue;
            if (inputValue) {
              this.editForm.newlabels.push(inputValue);
            }
            this.inputVisible = false;
            this.inputValue = '';
          },
          // cancelForm() {
          //   this.$router.go(-1);
          // },
          submitForm(formName){
            console.log("submitForm> formName:%o, editForm:%o", formName, this.editForm);
            this.$refs[formName].validate((valid) => {
              if (valid) {
                let params = cloneObj(this.editForm);
                let nl = params.newlabels;
                let l = params.tags;
                l = l.concat(nl);
                l.push(newsType[params.rating]);
                console.debug("submitForm> before l:%o", l);
                l = this.arryDerep(l); //l.derep();
                console.debug("submitForm> after l:%o", l);

                params.newlabels = params.newlabels.join('#');
                params.tags = l.join('#');
                // params.sourcefrom = params.sourcefrom[0]//newsPlatform[params.sourcefrom];

                console.debug("submitForm> id:%o, newlabels:%o, labels:%o", params.id, params.newlabels, params.tags);
                if(params.id){
                  this.editNewsContent(params).then(
                    (resp) => {
                    console.debug("editNewsContent> resp:%o", resp);
                      if(resp.code === 0){
                          this.$message({
                              message: resp.msg,
                              type: 'success'
                          })
                          console.debug("editNewsContent> newContent:%o", this.newContent);
                          this.$router.push({ path: './review',query: { id: this.newContent.id }})
                      }else{
                        this.$message({
                              message: resp.msg,
                              type: 'error'
                          })
                      }
                    }
                  );
                }else{
                  params.edittime = getNowTime('yyyy-mm-dd hh:mm:ss');
                  this.addNewsContent(params).then(
                    (resp) => {
                    console.debug("addNewsContent> resp:%o", resp);
                      if(resp.code === 0){
                          this.$message({
                              message: resp.msg,
                              type: 'success'
                          })
                          console.debug("addNewsContent> newContent:%o", this.newContent);
                          this.$router.push({ path: './review',query: { id: this.newContent.id }})
                      }else{
                        this.$message({
                              message: resp.msg,
                              type: 'error'
                          })
                      }
                    }
                  );
                }
              } else {
                console.log('error submit!!');
                return false;
              }
            });

          },
          // reviewText(id){
          //   //location.href = './review';
          //   this.$router.push({ path: './review',query: { id }})
          // },
          handleSceneIconClick() {
            this.editForm.scenario = '';
          },
          handleTitleIconClick() {
            this.editForm.title = '';
          },

          arryDerep(arry){
              var res = [];
              var json = {};
              for(var i = 0; i < arry.length; i++){
                  if(!json[arry[i]]){
                      res.push(arry[i]);
                      json[arry[i]] = 1;
                  }
              }
              return res;
          },
          //音频文件上传处理
          handleRemove( file, fileList ){

          },
          handleSuccess( response, file, fileList ){
            console.log(response);
            console.debug("handleSuccess> file:%o, fileList:%o", file, fileList);
            let filetype = fileList.name.split(".")[fileList.name.split(".").length-1];
            console.log("filetype:%o", filetype);
            this.editForm.url = "http:"+ this.cdnPostUrl/*this.postUrl*/ + this.headerFolder + this.postbFolder + this.newContent.id +'.'+ filetype//fileList.name;
            this.editForm.mediasize = fileList.raw.size;
            console.log("handleSuccess> mediaurl:%s, mediasize:%o", this.editForm.mediaurl, this.editForm.mediasize);
          },
          handleError( err, file, fileList ){
            this.$message({
                  message: '文件上传失败!',
                  type: 'error'
              });
          },
          handleBeforeUpload( file ){
            console.log(file);
            let filetype = file.name.split(".")[file.name.split(".").length-1];
            let fileName = file.name.slice(0,file.name.length-4);
            let userFileName = this.$store.state.login.account || sessionStorage.getItem('userName');
            // console.log(userFileName);
            if(this.newContent.url){
              let curFolder = this.newContent.url.split('/');
              console.log("handleBeforeUpload> curFolder:%o", curFolder);

              let curFileName = curFolder[curFolder.length-1].split('.');
              let a = curFileName[0];
              if(a.lastIndexOf('-v') === -1){
                let b = a+'-v1';       
              }else{
                let c = a.lastIndexOf('-v');
                let d = a.lastIndexOf('.');
                let e = a.slice(c+1,d);
                let f = a[0]+e+'.'+a[1];
              }

              this.postbFolder = userFileName + '/'+curFolder[curFolder.length-2]+'/';

              this.editForm.data['osspath'] = this.headerFolder + this.postbFolder + this.newContent.id+'.'+filetype;

            }else{
              let curFolder = getNowTime();
              this.postbFolder = userFileName + '/'+curFolder+'/';
              this.editForm.data['osspath'] = this.headerFolder + this.postbFolder +fileName+'-v1'+'.'+filetype;
            }
            
            this.editForm.data['token'] = this.token('joke' ,'jokekey');
            const isMusic = (file.type === 'audio/mp3')||(file.type === 'audio/wma')||(file.type === 'audio/wav');
            const isLt2M = file.size / 1024 / 1024 < 8;
            let judge = false;

            if (!isMusic) {
              this.$message.error('上传音乐文件只能是 mp3/wma/wav 格式!');
            }
            if (!isLt2M) {
              this.$message.error('上传音乐文件大小不能超过 8MB!');
            }
            judge = isMusic && isLt2M ;
            if(judge){
              this.editForm.uploadloading = true;
              console.debug("handleBeforeUpload> uploadloading:%o", this.editForm.uploadloading);
            }
            return judge;
          },
          token(name,key){
              var exp = new Date()
              let timestamp = Math.round(exp.getTime() / 60000)
              let tempstr = name + key + timestamp

              let tmeptoken = CryptoJS.MD5(tempstr).toString().toUpperCase()
              // console.log(tempstr)
              // console.log(tmeptoken)
              return name +'.'+ timestamp +'.'+ tmeptoken
          }
        },
        components: {
            // markdownEditor
        }
    }
</script>
<style scoped>
    .editor-btn{
        margin-top: 20px;
    }

    .header{
        background: white;
        /*padding: 0 20%;*/
        height: 60px;
        border: 1px solid #939393;
        /*border-style: solid dotted dashed double;*/
        border-top: none;
        border-left: none;
        border-right: none;
        /*display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;*/
        position: fixed;
        z-index: 1;
        width: 100%;
    }
    .header .header-tips{
      /*font-size: 10px;*/
      color: #939393;
      /*width: 80%;*/
      /*border: 1px solid black;
      display: inline-flex;
      flex-direction: row;
      justify-content: flex-start;*/
    }
    .header .header-tips .header-tips-audio{
      /*border: 1px solid blue;*/
      width: 500px;
    }
    .header .header-btn{
      /*border: 1px solid black;*/
      /*width: 150px;
      display: inline-flex;
      flex-direction: row;
      justify-content: space-between;*/

      /* border: 1px solid black; */
      /* width: 150px; */
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      margin: 8px 0;

    }

    .editor-content{
      /*border: 1px solid blue;*/
      margin: 0 auto;
      /*width: 60%;*/
      /*height: 600px;*/
      padding: 40px 10px;
      background: white;
    }

    .editor-content .editor-content-tags{
      margin: 0 5px;
    }
    .input-new-tag{
      width: 120px;
    }

    .el-autocomplete {
        width: 100%;
    }
    .check-url {
      margin-left:80px;
      margin-bottom: 10px;
    }
    .submit-btn {
      margin-left: 80px;
    }
</style>



// WEBPACK FOOTER //
// src/components/common/edit.vue